import React, { memo } from "react";
import styled from "styled-components";
import { BIBLE_BOOK_NAMES_DATA } from "../../../../bible_page_data";

const HistoryItem = styled.div`
  display: flex;
  align-items: center;
  min-height: 24px;
  max-height: 24px;
  padding: 0 8px;
  border-radius: 8px;
  color: #1e1e1e;
  font-size: 12px;
  border: 1px solid #d9d8fa;
  transition: 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #d9d8fa;
  }
`;

const BibleHistoryItem = ({
  historyItem,
  bibleTranslations,
  handleHistoryItemClick,
}) => {
  const bibleId = historyItem.b;
  const bookId = historyItem.bk;
  const chapterId = historyItem.ch;

  const bibleLocale = bibleTranslations?.find(
    (translation) => translation.bible_code === bibleId
  )?.bible_locale;

  const bookName = BIBLE_BOOK_NAMES_DATA[bibleLocale]?.[bookId]?.name;

  return (
    <HistoryItem onClick={() => handleHistoryItemClick(historyItem)}>
      {bookName} {chapterId}
    </HistoryItem>
  );
};

export default memo(BibleHistoryItem);
